// IIFE
var timer = null;
var searchBoxIndex = 0;

$ = jQuery;
$(document).ready(function(){
  document.addEventListener("keydown", (e) => {
    if(
      $(`#${$(e.target).attr("id")}`).is(":focus") ||
      $(`#header .search-box .search-box__item > a`).is(":focus")
    ){
      let container = $(e.target).closest("header").attr("id");
      if (!container) return;
      $(`#${container} .search-box .search-box__link--active`).removeClass("search-box__link--active");

      if(e.key === "ArrowUp"){
        searchBoxIndex--;
        searchBoxIndex = (searchBoxIndex <= 0) ? 1 : searchBoxIndex;

        setTimeout(() => {
          let len = $(e.target).value.length * 2;
          $("#header-search-field")[0].setSelectionRange(len, len);
        }, 0)
      }

      if(e.key === "ArrowDown"){
        searchBoxIndex++;
        let length = $(`#${container} .search-box .search-box__item`).length;
        searchBoxIndex = (searchBoxIndex > length) ? length : searchBoxIndex;
      }

      $(`#${container} .search-box .search-box__item:nth-child(${searchBoxIndex}) > a`).addClass("search-box__link--active");

      if(e.key === "Enter"){
        let href = $(`#${container} .search-box .search-box__link--active`).attr("href");
        window.location.href = href !== undefined ? href : `${$(e.target).data('baseUrl')}search/node?keys=${e.target.value}`;
      }
    }
  });
})


function setSearchLoader(loader, boolean){
  if(boolean){
    loader.append(`
      <li class="search-box__item search-loader">
        <a class="search-box__link text-center"><i class="fas fa-spinner fa-spin"></i></a>
      </li>
    `);
  }else{
    loader.find(".search-loader").remove();
  }
}

function search(appendResultsSelector, ref, e){
  appendResultsSelector.html("");
  searchBoxIndex = 0;
  if(e.target.value.trim().length <= 0){ return; }
  clearTimeout(timer);
    timer = setTimeout(() => {
      setSearchLoader(appendResultsSelector, true);
      $('#search-container').load(`${ref.attr("data-base-url")}search/node?keys=${e.target.value} .search-results.node_search-results`, function(res, status){
        if(status === "success"){
          let html = ``;
          $('.node_search-results > li .search-result__title > a').each(function(key,item) {
            html += `
              <li class="search-box__item">
                <a href="${$(this).attr("href")}" class="search-box__link">${$(this).text()}</a>
              </li>
            `;
          })

          if(html === ``){
            html += `
            <li class="search-box__item">
              <a class="search-box__link">Não encontramos o que você procura.</a>
            </li>
          `;
          }

          appendResultsSelector.html("");
          appendResultsSelector.append(html);
          setSearchLoader(appendResultsSelector, false);
          $("#search-container").html("");
        }
      })
    }, 1000);
}

;(($) => {
  $('#header-search-field').on('input', function(e) {
    search($("#header .search-box"), $(this), e);
  })

  $('#scroll-header-search-field').on('input', function(e) {
    search($("#scroll-header .search-box"), $(this), e);
  })

  $('#mobile-search-field').on('input', function(e) {
    search($("#mobile-navbar .search-box"), $(this), e);
  })

  $("#scroll-header .search-icon i.mi").on("click", () => {
    let field = $("#scroll-header .search");
    let hasClass = field.hasClass("show");
    hasClass ? field.removeClass("show") : field.addClass("show");
  })

  document.addEventListener("click", (e) => {
    if(!$(e.target).closest(".search-box")){
      $("#header .search-box, #scroll-header .search-box").html("");
      $("#search-container").html("");
      // $('body').css('overflow', 'auto');
    }
  })

})(jQuery)
